<button
  [type]="type"
  [disabled]="disabled"
  [ngClass]="classes"
  class="inline-flex items-center border border-secondary-blue-5 bg-primary-accessible-blue px-3 py-2 font-medium leading-4 text-white duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-secondary-blue-5"
>
  <ng-content></ng-content>
</button>
